<template>
  <div class="no-flagship-posts">
    <div ref="flag" class="lottie-flag" />
    <div class="flagship-text">
      <h5>No Flagship jobs yet</h5>
      <p>{{ text }}</p>
      <a
        href="https://help.datapeople.io/article/310-what-is-a-flagship-job"
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn more here
      </a>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed, useTemplateRef, onMounted } from 'vue';
import { useAppAuthData } from '@/stores/app/authData';

const { isAdmin } = storeToRefs(useAppAuthData());

const flagRef = useTemplateRef('flag');

const text = computed(() => {
  if (isAdmin.value) return 'Highlight your best-in-class jobs here to guide your team.';
  return 'Your team hasn\'t added any best-in-class jobs yet. Check back soon or reach out to your admin for guidance.';
});

onMounted(async () => {
  const { default: flagshipNoJobs } = await import('@/assets/lottieFiles/flagship-no-jobs');
  const { default: lottie } = await import('lottie-web/build/player/lottie_light');

  lottie.loadAnimation({
    container: flagRef.value,
    renderer: 'svg',
    autoplay: true,
    loop: 1,
    animationData: flagshipNoJobs,
    initialSegment: [0, 275],
  });
});
</script>

<style scoped lang="less">
@import '@/less/mixins';

.no-flagship-posts {
  .shadow();
  background: @white;
  padding: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lottie-flag {
  height: 275px;
  margin-right: 24px;
}

.flagship-text {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 186px;

  h5 {
    font-weight: 700;
    line-height: 150%;
    font-size: 14px;
    color: @text-darkest;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    color: @text-darkest;
  }

  a {
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    color: @text-brand;
  }
}
</style>
